import AnthropometricMetadataProvider from "providers/AnthropometricMetadataProvider";
import CoachesProvider from "providers/CoachesProvider";
import ExercisesProvider from "providers/ExercisesProvider";
import FeatureFlagProvider from "providers/FeatureFlagProvider";
import HyroxMetadataProvider from "providers/HyroxMetadataProvider";
import MetadataProvider from "providers/MetadataProvider";
import RoleProvider from "providers/RoleProvider";
import WellnessMetadataProvider from "providers/WellnessMetadataProvider";

interface DataProvidersProps {
  children: React.ReactNode;
}

/**
 * DataProviders is a wrapper component that provides the primary data providers
 * used in the application.
 *
 * These providers are essential for the initial loading
 * of the app and include providers for feature flags, roles, exercises, wellness metadata,
 * anthropometric metadata, and general metadata.
 */
function DataProviders(props: DataProvidersProps) {
  return (
    <FeatureFlagProvider>
      <RoleProvider>
        <CoachesProvider>
          <ExercisesProvider>
            <WellnessMetadataProvider>
              <AnthropometricMetadataProvider>
                <HyroxMetadataProvider>
                  <MetadataProvider>{props.children}</MetadataProvider>
                </HyroxMetadataProvider>
              </AnthropometricMetadataProvider>
            </WellnessMetadataProvider>
          </ExercisesProvider>
        </CoachesProvider>
      </RoleProvider>
    </FeatureFlagProvider>
  );
}

export default DataProviders;
